@if (readyForTeam || isInTeam) {
  <section class="team-status">
    <h2 class="team-status__title" i18n="@@employment.team.teamStatus">Team-Status</h2>
    @if (readyForTeam) {
      <p class="team-status__p" i18n="@@employment.team.contentTeamStatus">Sie können andere Personen in ihr Team
            einladen. Wenn die andere Person die Einladung annimmt, können beide Parteien die Informationen im
            erweiterten Profil sehen.</p>
      <button (click)="ivite()" [disabled]="(isLoading$ | async) !== false" class="button secondary" type="submit">
        <span aria-hidden="true" class="icon icon-plus"></span>
        <ng-container i18n="@@employment.team.btnInviteToTeam">In Team einladen</ng-container>
      </button>
    }
    @if (isInTeam) {
      <p class="team-status__p" i18n="@@employment.team.contentPersonInTeam">Personen die in Ihrem Team sind, haben
            automatisch Zugriff auf Ihr erweitertes Profil, um z. B. Kontaktdaten zu sehen.</p>
      <div class="info-label info-label--green">
        <div class="info-label__icon">
          <span aria-hidden="true" class="icon icon-check"></span>
        </div>
        <div class="info-label__text" i18n="@@employment.team.inTeam">{{ companionName }} ist Mitglied in Ihrem
                Team
            </div>
      </div>
      <button (click)="removeFromTeam()" [disabled]="(isLoading$ | async) !== false"
        class="button warning revoke-access-btn"
        type="button">
        @if (!isPA) {
          <ng-container i18n="@@employment.conversation.team.btnRemoveFromTeam">Aus dem Team entfernen
            </ng-container>
        }
        @if (isPA) {
          <ng-container i18n="@@employment.conversation.team.btnPARemoveFromTeam">Aus dem Team
                austreten
            </ng-container>
        }
      </button>
    }
  </section>
}
